import request from '@/utils/request'

/**
 * 第三方登录
 * @param params
 */
export function login(params) {
  return request({
    url: process.env.WEB_API + '/oauth/render',
    method: 'post',
    params
  })
}

export function authVerify(params) {
  return request({
    url: process.env.WEB_API + '/oauth/verify/' + params,
    method: 'get',
  })
}

export function editUser(params) {
  return request({
    url: process.env.WEB_API + '/oauth/editUser',
    method: 'post',
    data: params
  })
}

/**
 * 更新用户密码
 * @param params
 */
export function updateUserPwd(params) {
  return request({
    url: process.env.WEB_API + '/oauth/updateUserPwd',
    method: 'post',
    data: params
  })
}

/**
 * 获取用户反馈
 * @param params
 */
export function getFeedbackList(params) {
  return request({
    url: process.env.WEB_API + '/oauth/getFeedbackList',
    method: 'get',
    params
  })
}

/**
 * 新增反馈
 * @param params
 */
export function addFeedback(params) {
  return request({
    url: process.env.WEB_API + '/oauth/addFeedback',
    method: 'post',
    data: params
  })
}

/**
 * 新增匿名反馈
 * @param params
 */
export function addAnonyFeedback(params) {
  return request({
    url: process.env.WEB_API + '/oauth/addAnonyFeedback',
    method: 'post',
    data: params
  })
}

export function deleteUserAccessToken(params) {
  return request({
    url: process.env.WEB_API + '/oauth/delete/' + params,
    method: 'post',
  })
}

/**
 * 本地登录
 * @param params
 */
export function localLogin(params) {
  return request({
    url: process.env.WEB_API + '/login/login',
    method: 'post',
    data: params
  })
}

/**
 * 本地注册
 * @param params
 */
export function localRegister(params) {
  return request({
    url: process.env.WEB_API + '/login/register',
    method: 'post',
    data: params
  })
}

export function logout(params) {
  return request({
    url: process.env.WEB_API + '/user/logout',
    method: 'post',
    data: params
  })
}

/**
 * 获取微信公众号登录二维码
 * @param params
 * @returns {*}
 */
export function getWechatOrCodeTicket(params) {
  return request({
    url: process.env.WEB_API + '/wechat/getWechatOrCodeTicket',
    method: 'get',
    data: params
  })
}

export function getUserLoginStatus(params) {
  return request({
    url: process.env.WEB_API + '/wechat/getUserLoginStatus',
    method: 'get',
    params
  })
}

/**
 * 获取验证码
 * @param params
 */
export function getValidCode(params) {
  return request({
    url: process.env.WEB_API + '/login/code',
    method: 'post',
    data: params
  })
}

/**
 * 注册获取验证码
 * @param params
 */
export function registerGetValidCode(params) {
  return request({
    url: process.env.WEB_API + '/login/registerCode',
    method: 'post',
    data: params
  })
}

/**
 * 验证验证码
 * @param params
 */
export function validCode(params) {
  return request({
    url: process.env.WEB_API + '/login/validCode',
    method: 'post',
    data: params
  })
}

/**
 * 重设密码
 * @param params
 */
export function resetPwd(params) {
  return request({
    url: process.env.WEB_API + '/login/resetPwd',
    method: 'post',
    data: params
  })
}

/**
 * 修改手机号码获取验证码
 * @param params
 */
export function changeMobileGetValidCode(params) {
  return request({
    url: process.env.WEB_API + '/login/changeMobileCode',
    method: 'post',
    data: params
  })
}

/**
 * 修改手机号码
 * @param params
 */
export function doChangeMobile(params) {
  return request({
    url: process.env.WEB_API + '/login/changeMobile',
    method: 'post',
    data: params
  })
}

/**
 * 修改邮箱地址获取验证码
 * @param params
 */
export function changeEmailGetValidCode(params) {
  return request({
    url: process.env.WEB_API + '/login/changeEmailCode',
    method: 'post',
    data: params
  })
}

/**
 * 修改邮箱地址
 * @param params
 */
export function doChangeEmail(params) {
  return request({
    url: process.env.WEB_API + '/login/changeEmail',
    method: 'post',
    data: params
  })
}

/**
 * 获取图形验证码
 * @param params
 */
export function captcha (params) {
  return request({
    url: process.env.WEB_API + '/login/captcha',
    method: 'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js